export type CsvCell = string | number | null | undefined;
export type CsvRow = Record<string, CsvCell>;

export function downloadCsv(filename: string, rows: CsvRow[]) {
  if (rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const cell = (value: CsvCell) => {
    const text = value == null ? "" : String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const csv = [
    headers.join(","),
    ...rows.map((row) => headers.map((key) => cell(row[key])).join(",")),
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function toIsoDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function defaultDateWindow(days: number) {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - (days - 1));
  return { from: toIsoDate(start), to: toIsoDate(end) };
}

export function monthsAgoWindow(months: number) {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth() - months, end.getDate());
  return { from: toIsoDate(start), to: toIsoDate(end) };
}

export function spanDays(from: string, to: string) {
  const start = new Date(`${from}T00:00:00`);
  const end = new Date(`${to}T00:00:00`);
  if (!from || !to || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
    return null;
  }
  return Math.round((end.getTime() - start.getTime()) / 864e5) + 1;
}

export function monthsInRange(from: string, to: string) {
  const span = spanDays(from, to);
  if (span == null) return 6;
  return Math.min(24, Math.max(1, Math.round(span / 30)));
}

export function formatDateLabel(iso: string) {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
